export enum SearchDataEventObject {
  HINT_DROPDOWN = 'hint_dropdown',
  EMPTY_STATE = 'empty_state', // 'No results' component in P3.
  EXIT = 'exit', // Exit button, when the search bar's location is DOCKED.
  CLEAR_QUERY = 'clear_query', // Clear button, when the search bar's location is POPOVER.
  SESSION_START = 'session_start',
  SESSION_END = 'session_end',
}
